import { ANALYTICS_VIEW_FEATURE_LOCATIONS } from 'dpl/constants/analytics';

export const TAB_KEYS = {
  OVERVIEW: 'overview',
  DOGS: 'dogs',
  UPDATES: 'updates',
  /* TODO: Uncomment when ready */
  // PROGRAM: 'program',
  STORIES: 'stories'
};

export const TAB_NAMES = {
  [TAB_KEYS.OVERVIEW]: 'Overview',
  [TAB_KEYS.DOGS]: 'Litters & puppies',
  [TAB_KEYS.UPDATES]: 'Updates',
  /* TODO: Uncomment when ready */
  // [TAB_KEYS.PROGRAM]: 'About the program',
  [TAB_KEYS.STORIES]: 'Owner stories'
};

export const TAB_VIEW_FEATURE_LOCATIONS = {
  [TAB_KEYS.OVERVIEW]: ANALYTICS_VIEW_FEATURE_LOCATIONS.OVERVIEW_TAB,
  [TAB_KEYS.DOGS]: ANALYTICS_VIEW_FEATURE_LOCATIONS.LITTERS_AND_PUPPIES_TAB,
  [TAB_KEYS.UPDATES]: ANALYTICS_VIEW_FEATURE_LOCATIONS.UPDATES_TAB,
  [TAB_KEYS.STORIES]: ANALYTICS_VIEW_FEATURE_LOCATIONS.OWNER_STORIES_TAB
};

export const PAGE_CATEGORIES = {
  [TAB_KEYS.OVERVIEW]: 'breeder-profile',
  [TAB_KEYS.DOGS]: 'breeder-profile-tab-litters-and-puppies',
  [TAB_KEYS.UPDATES]: 'breeder-profile-tab-updates',
  [TAB_KEYS.STORIES]: 'breeder-profile-tab-owner-stories'
};

export const MOBILE_TAB_KEYS = {
  OVERVIEW: 'overview',
  ABOUT: 'about',
  STORIES: 'stories',
  UPDATES: 'updates'
};

export const MOBILE_TAB_NAMES = {
  [MOBILE_TAB_KEYS.OVERVIEW]: 'Overview',
  [MOBILE_TAB_KEYS.ABOUT]: 'About',
  [MOBILE_TAB_KEYS.STORIES]: 'Reviews',
  [MOBILE_TAB_KEYS.UPDATES]: 'Updates'
};

export const MOBILE_PAGE_CATEGORIES = {
  [MOBILE_TAB_KEYS.OVERVIEW]: 'breeder-profile-tab-overview',
  [MOBILE_TAB_KEYS.ABOUT]: 'breeder-profile-tab-about',
  [MOBILE_TAB_KEYS.UPDATES]: 'breeder-profile-tab-updates',
  [MOBILE_TAB_KEYS.STORIES]: 'breeder-profile-tab-owner-stories'
};

export const STICKY_BOTTOM_FEATURE_LOCATIONS = {
  [MOBILE_TAB_KEYS.ABOUT]:
    ANALYTICS_VIEW_FEATURE_LOCATIONS.ABOUT_TAB_STICKY_BOTTOM,
  [MOBILE_TAB_KEYS.OVERVIEW]:
    ANALYTICS_VIEW_FEATURE_LOCATIONS.OVERVIEW_TAB_STICKY_BOTTOM,
  [MOBILE_TAB_KEYS.STORIES]:
    ANALYTICS_VIEW_FEATURE_LOCATIONS.REVIEWS_TAB_STICKY_BOTTOM,
  [MOBILE_TAB_KEYS.UPDATES]:
    ANALYTICS_VIEW_FEATURE_LOCATIONS.UPDATES_TAB_STICKY_BOTTOM
};

export const MOBILE_LAYOUTS = {
  NEW: 'new'
};
